import EmptyList from '@/components/Common/EmptyList';
import _groupBy from 'lodash.groupby';
import AgentsListItem from './AgentsListItem';
import AgentSearchPanel from './AgentsListSearchPanel';
import WorkHoursOperationForm from '@/components/Projects/Common/WorkHoursOperationForm';
import { hDeepCopy } from '@/utils/helpers';

// @vue/component
export default {
  name: 'AgentsList',

  components: {
    EmptyList,
    AgentsListItem,
    AgentSearchPanel,
    WorkHoursOperationForm,
  },

  props: {
    projectUuid: {
      type: String,
      default: () => ({}),
    },
  },

  data() {
    return {
      isModalVisible: false,
      editableAgent: undefined,
      isEmptyOnStartup: true,
      isWorkHoursModalVisible: false,
      PAGE_SIZE_OPTIONS: [1, 20, 50, 100],
      agentsPerPage: 20,
      currentPage: 1,
      filterBy: {
        name: '',
        nr_tel: '',
        type: '',
        active: true,
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/agents/getList', 'client/project/agents/removeAgent',
        'client/project/agents/restoreAgent',
      ]);
    },
    agentsList() {
      return this.$store.getters['client/project/agents/list'].records;
    },
    agentsListFiltered() {
      let agents = hDeepCopy(this.agentsList);
      if (this.filterBy.name) {
        agents = agents.filter(agent => agent.name.toLowerCase().includes(this.filterBy.name.toLowerCase()));
      }
      if (this.filterBy.nr_tel) {
        agents = agents.filter(agent => agent.nr_tel.toLowerCase().includes(this.filterBy.nr_tel.toLowerCase()));
      }
      if (this.filterBy.type) {
        agents = agents.filter(agent => agent.type === this.filterBy.type);
      }
      if (this.filterBy.active === false) {
        agents = agents.filter(agent => !agent.active);
      }
      if (this.filterBy.active) {
        agents = agents.filter(agent => agent.active);
      }
      if (this.$store.getters['authorization/acl'].hasPermission('agent_show_only_from_group')) {
        agents = agents.filter((item) => {
          return this.$store.getters["client/groups/list"].some(group => group.id === item.group_agents);
        });
      }
      return agents;
    },
    agentsToRenderPerPage() {
      return this.agentsListFiltered.slice((this.currentPage - 1) * this.agentsPerPage, this.currentPage * this.agentsPerPage);
    },
    isFiltered() {
      return this.filterBy.onlyFreeAgents || this.filterBy.name.length
      || this.filterBy.nr_tel.length || this.filterBy.type.length
      || this.filterBy.active === false || this.$store.getters['authorization/acl'].hasPermission('agent_show_only_from_group');
    },
    connectionTypeList() {
      return _groupBy(this.$store.getters['connections/types/list'].records, 'type');
    },
  },

  watch: {
    filterBy: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    agentsPerPage: {
      handler() {
        this.currentPage = 1;
      },
    },
  },

  async created() {
    window.addEventListener('resize', this.debounce(this.windowWidthChanged));
    this.windowWidthChanged();
    await this.$store.dispatch('client/project/agents/getList', { project: this.projectUuid });
    await this.$store.dispatch("client/groups/getGroupsList");
    this.isEmptyOnStartup = this.$store.getters['client/project/agents/list'].total === 0;
    await this.$store.dispatch('connections/types/getTypeList');
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidthChanged);
  },

  methods: {
    handleRefreshList() {
      this.$store.dispatch('client/project/agents/getList', { project: this.projectUuid });
    },
    async handleChangePage(page) {
      this.currentPage = page;
    },
    changeFilterBy(value) {
      this.filterBy = value;
    },
    handleCreateOrEditAgent(agent) {
      this.editableAgent = agent;
      this.isModalVisible = true;
    },
    handleEditWorkHours(agent) {
      this.editableAgent = agent;
      this.isWorkHoursModalVisible = true;
    },
    windowWidthChanged() {
      if (window.innerWidth >= 1725 && window.innerWidth < 2275) {
        this.PAGE_SIZE_OPTIONS = [9, 18, 27, 60, 99];
        this.agentsPerPage = 18;
      } else {
        this.PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
        this.agentsPerPage = 20;
      }
    },
    debounce(func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    },
  },
};
